<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3913 3.6969L8.32603 0.11699L8.32312 0.115521C8.0085 -0.0411037 7.63472 -0.0376036 7.32306 0.124896C7.29853 0.135271 0.613031 3.68358 0.5905 3.69808C0.22625 3.88877 0 4.26246 0 4.67374V11.3263C0 11.7376 0.22625 12.1112 0.5905 12.3019L7.32003 15.8736L7.32306 15.8751C7.482 15.958 7.65716 15.9996 7.83234 15.9996C8.00062 15.9996 8.16897 15.9612 8.32312 15.8845L15.3913 12.3031C15.7668 12.1153 16 11.7381 16 11.3181V4.6819C16 4.26193 15.7668 3.88468 15.3913 3.6969ZM7.75741 0.955334C7.80331 0.931771 7.85816 0.931303 7.90444 0.954021L14.5178 4.30493L11.9439 5.58637L5.47837 2.1649L7.75741 0.955334ZM7.357 14.8322L1.02844 11.4734L1.02541 11.4718C0.971 11.4434 0.937156 11.3877 0.937156 11.3263V5.09665L7.357 8.44427V14.8322ZM7.83053 7.63424L1.446 4.30502L4.478 2.69587L10.9116 6.1004L7.83053 7.63424ZM15.0628 11.3182C15.0628 11.3808 15.0279 11.4371 14.9718 11.4651L8.29419 14.8485V8.4503L11.3687 6.91965V8.52449C11.3687 8.78327 11.5786 8.99308 11.8373 8.99308C12.0961 8.99308 12.3059 8.78327 12.3059 8.52449V6.45308L15.0628 5.08058V11.3182Z"
      fill="#FCC210"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
